import React from "react";
import { Link } from "../Router";
import Label from "../atoms/Label";
import { MEDIUM } from "../util/breakpoints";
import useSiteData from '../../useSiteData'
import useMediaQuery from '../util/useMediaQuery'

const generateSlug = (homeSlug, slug, page, queryParams) => {
    page = page === 1 ? null : page;

    if (!page) {
        return homeSlug + "/" + (queryParams || '');
    }

    return '/' + slug + "/" + page + "/" + (queryParams || '');
};

// Could be external but seems very specific
const PageLink = ({ digit = 0, isActive, slug: to }) =>
    <Link
        to={ to }
        className={ "o-pagination__link" +
        (isActive ? " o-pagination__link--active" : "") +
        " a-btn a-btn--transparent" }
    >
        { digit }
    </Link>;

const Items = ({ activePage, homeSlug, slug, queryParams, pageCount }) => {

    const isDesktop = useMediaQuery({ minWidth: MEDIUM });
    const maxItems = isDesktop ? 9 : 7;
    const midIndex = Math.floor(maxItems / 2);

    return (
        <div className="o-pagination__links">
            { Array(Math.min(pageCount, maxItems)).fill(null).map((_, index) => {

                let pageIndex = index + 1;
                if (pageCount > maxItems) {
                    pageIndex = index + Math.min(Math.max(1, activePage - midIndex), pageCount - maxItems + 1);
                }

                if (index === maxItems - 2 && pageCount > maxItems && activePage < pageCount - midIndex) {
                    return <Label key={ index } classes="o-pagination__link" isRed text="..."/>;
                }

                // The last link is always to the last page
                if ((index + 1) === maxItems) {
                    pageIndex = pageCount;
                }

                return (
                    <PageLink
                        key={ index }
                        digit={ pageIndex }
                        isActive={ pageIndex === activePage }
                        slug={ generateSlug(homeSlug, slug, pageIndex, queryParams) }
                    />
                );
            }) }
        </div>
    );
};

export default props => {
    const { translations } = useSiteData().pageSettings;

    let {
        previousText = (translations.previous ? translations.previous : "Previous"),
        nextText = (translations.next ? translations.next : "Next"),
        pageCount = 10,
        activePage = 1,
        slug = "",
        homeSlug = "",
        queryParams
    } = props;

    activePage = parseInt(activePage);

    return (
        <div className="o-pagination">
            <Items { ...props } />
            <div className="o-pagination__prev">
                { activePage > 1 &&
                <Link
                    to={ generateSlug(homeSlug, slug, activePage - 1, queryParams) }
                    className="a-btn a-btn--transparent"
                >
                    { previousText }
                </Link>
                }
            </div>
            <div className="o-pagination__next">
                { activePage < pageCount &&
                <Link
                    to={ generateSlug(homeSlug, slug, activePage + 1, queryParams) }
                    className="a-btn a-btn--transparent"
                >
                    { nextText }
                </Link>
                }
            </div>
        </div>
    );
}

